export default __webpack_public_path__ + "static/mountains-cd122e97e6d67e4347da56b8bdb85804.mp4";